import React, { Fragment } from "react";
import './MenuProfile.scss'

const MenuProfile = ({ menu_items, selected, setSelected, user, handleLogout, extendedProps, firstLoad, className }) => {

    const isDisabled = (el) => {
        if (!el?.disabled) return false;
        if (typeof el.disabled === 'function') {
            return el.disabled(user);
        }
        return el.disabled;
    };

    return (
        <Fragment>
            <div className={`menu-profile ${className}`}>
                {menu_items.map((el, index) =>
                    <div
                        key={el.name}
                        className={`menu-item ${isDisabled(el) ? "disabled" : ""} ${selected.name === menu_items[index].name ? 'selected' : ''}`}
                        onClick={() => {
                            if (isDisabled(el)) {
                                return;
                            }
                            setSelected(el)
                        }}
                    >
                        <span className={``}>{el.label}</span>
                    </div>
                )}
            </div>
            {selected.render({ user, handleLogout, ...extendedProps, firstLoad })}
        </Fragment>
    )
}

export default MenuProfile